import { queryClient } from '../queryClient';

/**
 * A chave e a limpeza da sessão moram separadas do `sessao.ts` porque o cliente de API
 * precisa derrubar a sessão quando recebe 401. Se ele importasse o `sessao.ts` — que
 * importa o próprio cliente — o ciclo `api → sessao → api` faria o TypeScript perder a
 * inferência do `sessaoQueryOptions`.
 *
 * Este módulo só depende do `queryClient`, então não fecha ciclo com ninguém.
 */
export const SESSAO_QUERY_KEY = ['sessao'] as const;

export function limparSessao() {
  queryClient.removeQueries({ queryKey: SESSAO_QUERY_KEY });
}
